import * as types from 'constants/monitoreosActionTypes';

const initialState = {
  loading: false,
  data: [],
  error: null,
  form: {
    loading: false,
    data: {},
    error: null
  }
};

export default (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case types.GET_MONITOREOS_EVENTOS_LOADING: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case types.GET_MONITOREOS_EVENTOS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        error: null,
        data: payload
      };
    }
    case types.GET_MONITOREOS_EVENTOS_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error
      };
    }
    default:
      return state;
  }
};
